/** @typedef {{ e: string, n: string }} HuntItem */

/** @typedef {{ id: string, ico: string, name: string, desc: string, items: HuntItem[] }} Pack */

/** @typedef {{ id: string, name: string, score: number }} Player */

/** @typedef {'lobby' | 'playing' | 'finished'} RoomStatus */

/**
 * @typedef {Object} RoomState
 * @property {string} code
 * @property {string} hostId
 * @property {Pack} pack
 * @property {Player[]} players
 * @property {number} round
 * @property {number} total
 * @property {boolean} active
 * @property {HuntItem | null} cur
 * @property {RoomStatus} status
 */

/** @typedef {{ player: string, img: string }} ProofEntry */

/**
 * Client -> server WebSocket messages
 * @typedef {(
 *   | { type: 'join', playerId: string, name: string }
 *   | { type: 'start' }
 *   | { type: 'slap', proofUrl?: string }
 *   | { type: 'rematch' }
 * )} ClientMessage
 */

/**
 * Server -> client WebSocket messages
 * @typedef {(
 *   | { type: 'state', room: RoomState }
 *   | { type: 'player_joined', player: Player }
 *   | { type: 'game_started' }
 *   | { type: 'round', round: number, cur: HuntItem, total: number }
 *   | { type: 'slap_result', winnerId: string, winnerName: string, proofUrl?: string, cur: HuntItem }
 *   | { type: 'finished', players: Player[], proofs: ProofEntry[] }
 *   | { type: 'error', message: string }
 * )} ServerMessage
 */

export const ROUND_DELAY_MS = 2400;

export function generatePlayerId() {
  return Math.random().toString(36).slice(2, 10);
}

export function generateRoomCode() {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let code = '';
  for (let i = 0; i < 4; i++) {
    code += chars[Math.floor(Math.random() * chars.length)];
  }
  return code;
}
